import { IoVolumeHigh, IoVolumeMute } from 'react-icons/io5';
import { useSettingsStore } from '../../../../store/settingsStore';
import { useThemeStore } from '../../../../store/themeStore';
import { Theme } from '../../../../store/types/theme';
import { stopThemeSound } from '../../../../utils/themeSounds';
import { stopSpeaking } from '../../../../utils/speech';

type MuteButtonProps = {
    currentTheme: Theme;
};

const MuteButton: React.FC<MuteButtonProps> = ({ currentTheme }) => {
    const { mute, setMute } = useSettingsStore();
    void useThemeStore(); // keep theme reactivity for color updates

    const toggleMute = () => {
        const newMute = !mute;
        setMute(newMute);
        if (newMute) {
            // Immediately stop any playing sounds / speech
            stopThemeSound();
            stopSpeaking();
        }
    };

    return (
        <button
            onClick={toggleMute}
            aria-label={mute ? 'Unmute' : 'Mute'}
            title={mute ? 'Unmute sounds' : 'Mute sounds'}
            className="flex size-11 shrink-0 items-center justify-center rounded-full active:brightness-90"
            style={{
                backgroundColor: mute ? 'rgba(128,128,128,0.4)' : `${currentTheme.color.point}33`,
                color: currentTheme.color.point,
            }}
        >
            {mute ? <IoVolumeMute size={22} /> : <IoVolumeHigh size={22} />}
        </button>
    );
};

export default MuteButton;
